let cfg = window.__APP_CONFIG__;

if (!cfg) {
    // Fallback for local dev with yarn serve
    cfg = {
        backendProtocol: process.env.VUE_APP_BACKEND_PROTOCOL || "http://",
        backendHost: process.env.VUE_APP_BACKEND_HOST || "localhost",
        backendPort: process.env.VUE_APP_BACKEND_PORT || ":9000",
        supplierPortalProtocol : process.env.VUE_APP_SUPPLIER_PORTAL_PROTOCOL,
        supplierPortalHost : process.env.VUE_APP_SUPPLIER_PORTAL_HOST,
        supplierPortalPort : process.env.VUE_APP_SUPPLIER_PORTAL_PORT,
        disableEslint: process.env.VUE_APP_DISABLE_ESLINT || false,
        nodeEnv: process.env.NODE_ENV || "development",
    };
}

export const API_BASE = `${cfg.backendProtocol}${cfg.backendHost}${cfg.backendPort}`;
console.log("API base domain: " + API_BASE);

// ---- OCDS open-data feed (public, unauthenticated) ----
export const OCDS_BASE = `${API_BASE}/api/v1/public/ocds`;
export const ocdsRecordsApi = (ocid, page, size) =>
    `${OCDS_BASE}/records?page=${page || 0}&size=${size || 20}${ocid ? `&ocid=${encodeURIComponent(ocid)}` : ''}`;
export const ocdsCompiledApi = (ocid) => `${OCDS_BASE}/records/${encodeURIComponent(ocid)}/compiled`;
export const ocdsVersionedApi = (ocid) => `${OCDS_BASE}/records/${encodeURIComponent(ocid)}/versioned`;
export const ocdsCompiledDownloadApi = (ocid) => `${OCDS_BASE}/records/${encodeURIComponent(ocid)}/compiled/download`;
export const ocdsVersionedDownloadApi = (ocid) => `${OCDS_BASE}/records/${encodeURIComponent(ocid)}/versioned/download`;
export const ocdsRecordPackagesApi = (page, size) =>
    `${OCDS_BASE}/record-packages?page=${page || 0}&size=${size || 10}`;
export const ocdsRecordPackageDownloadApi = (id) => `${OCDS_BASE}/record-packages/${id}/download`;
export const ocdsDataApi = () => `${OCDS_BASE}/ocds-data`;
export const ocdsDataDownloadApi = (artifact) => `${OCDS_BASE}/ocds-data/download/${artifact}`;
export const ocdsReportsApi = () => `${OCDS_BASE}/reports`;
export const ocdsReportApi = (key, params) => {
    const q = params
        ? new URLSearchParams(
            Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== '')
        ).toString()
        : '';
    return `${OCDS_BASE}/reports/${key}${q ? `?${q}` : ''}`;
};
export const ocdsReportFiltersApi = (key) => `${OCDS_BASE}/reports/${key}/filters`;
export const ocdsStatsApi = () => `${OCDS_BASE}/reports/stats`;


export const backendProtocol = cfg.backendProtocol;
export const backendHost = cfg.backendHost;
export const backendPort = cfg.backendPort;

export const supplierPortalProtocol = cfg.supplierPortalProtocol;
export const supplierPortalHost = cfg.supplierPortalHost;
export const supplierPortalPort = cfg.supplierPortalPort;

